import { useAtomValue } from 'jotai';

import { Stack, Tag } from '@ekhodealer/ekho-common/rev';

import { AccordionSection } from '@common/components/AccordionSection';
import { InfoLineItem } from '@common/components/InfoLineItem';

import { useGetOrderDetails } from '../../api/useGetOrderDetails';
import { orderDetailsDrawerAtom } from '../../atoms/orderDetailsDrawerAtoms';

import { SectionSkeleton } from './shared/SectionSkeleton';

const SECTION_TITLE = 'Fulfillment details';

export const FulfillmentDetailsSection = () => {
	const { selectedRow } = useAtomValue(orderDetailsDrawerAtom);
	const { data: orderDetails, isLoading } = useGetOrderDetails(
		selectedRow?.purchasedVehicleId || undefined,
	);

	if (isLoading) {
		return <SectionSkeleton title={SECTION_TITLE} />;
	}

	if (!orderDetails) {
		return null;
	}

	const { fulfillmentDetails } = orderDetails;

	const tempTagDisplay = fulfillmentDetails.tempTag ? 'Yes' : undefined;

	const trackingNumber = fulfillmentDetails.trackingNumber;
	const deliveryVendor = fulfillmentDetails.deliveryVendor;
	const vendorContact = fulfillmentDetails.vendorContact;

	const dispatchDate = fulfillmentDetails.dispatchDate || undefined;
	const estDeliveryDate = fulfillmentDetails.estimatedDeliveryDate || undefined;

	return (
		<AccordionSection title={SECTION_TITLE} defaultExpanded>
			<Stack itemsSpacing='12'>
				<InfoLineItem title='Fulfillment type' value={fulfillmentDetails.fulfillmentType} />
				<InfoLineItem
					title='Fulfillment status'
					content={
						<Tag size='medium' accent={1}>
							{fulfillmentDetails.fulfillmentStatus}
						</Tag>
					}
				/>
				<InfoLineItem title='Temp tag' value={tempTagDisplay} />
				<InfoLineItem title='Tracking number' value={trackingNumber} isCopyable />
				<InfoLineItem title='Delivery vendor' value={deliveryVendor} />
				<InfoLineItem title='Vendor contact' value={vendorContact} isCopyable />
				<InfoLineItem title='Dispatch date' value={dispatchDate} />
				<InfoLineItem title='Est. delivery date' value={estDeliveryDate} />
				{fulfillmentDetails.pickupAddress && (
					<InfoLineItem
						title='Pickup address'
						value={fulfillmentDetails.pickupAddress}
						isCopyable
					/>
				)}
				{fulfillmentDetails.deliveryAddress && (
					<InfoLineItem
						title='Delivery address'
						value={fulfillmentDetails.deliveryAddress}
						isCopyable
					/>
				)}
			</Stack>
		</AccordionSection>
	);
};
